import { FORUM_POSTS } from '../ids';
import { InstallLocation } from '../types';
export const ids = FORUM_POSTS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Profile,
    social: true,
    numbers: {
        key: 'postsCount',
        default: 0,
    },
    method: 'addSection',
    urlOverride: 'forum-posts',
    menuOrder: 2,
    page: {
        name: t('posts_page_name'),
        shortDescription: t('posts_page_short_description'),
        description: t('posts_page_description'),
        iconURL: `${staticsUrl}assets/images/icons/forum-icon.png`,
        origin: t('forum_origin'),
        screenshots: [
            `${staticsUrl}assets/images/forum-posts/forum-posts.png`,
            `${staticsUrl}assets/images/forum-posts/mobile-forum-posts.png`,
        ],
    },
});
//# sourceMappingURL=forum-posts.js.map